<template>
    <side-bar v-click-outside="hideSidebar" v-if="$permissions.sidebar()">
        <template slot="links">

            <sidebar-item :link="{ name: $t('common.dashboard'), icon: 'fas fa-th text-info' }"
                v-if="$permissions.sidebarDashboard()"
            >
                <sidebar-item :link="{ name: $t('common.sessions'), path: '/socrates/ui/dashboard/sessions' }"
                    v-if="$auth.hasOnePermission([
                        'dashboard.access-instructor-dashboard',
                        'dashboard.access-internal-observer-dashboard',
                        'dashboard.access-restricted-internal-observer-dashboard',
                        'dashboard.access-external-observer-dashboard',
                        'dashboard.access-learner-dashboard',
                    ])"
                >
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.grades'), path: '/socrates/ui/dashboard/grades' }"
                    v-if="$auth.hasPermission('dashboard.access-grades-from-dashboard')"
                >
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.logs'), path: '/socrates/ui/dashboard/logs' }"
                    v-if="$auth.hasPermission('dashboard.access-pilot-dashboard')"
                >
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.issues'), path: '/socrates/ui/dashboard/issues' }"
                    v-if="$auth.hasPermission('dashboard.access-issues-from-dashboard')"
                >
                </sidebar-item>

            </sidebar-item>

            <sidebar-item :link="{ name: $t('common.accounts'), icon: 'tim-icons icon-multiple-19 text-orange' }"
                v-if="$permissions.sidebarAccount()">

                <sidebar-item :link="{ name: $t('common.users'), path: '/socrates/ui/accounts/users' }"
                    v-if="$auth.hasOnePermission(['user.manage', 'user.manage-pilots', 'user.supervise'])">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.cohorts'), path: '/socrates/ui/accounts/cohorts' }"
                    v-if="$auth.hasPermission('cohort.manage')">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.roles'), path: '/socrates/ui/accounts/roles' }"
                    v-if="$auth.hasPermission('role.manage')">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.clients'), path: '/socrates/ui/accounts/entities' }"
                    v-if="$auth.hasPermission('entity.manage')">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.owners'), path: '/socrates/ui/accounts/owners' }"
                    v-if="$auth.hasPermission('owner.manage')">
                </sidebar-item>

            </sidebar-item>

            <sidebar-item :link="{ name: $t('common.training'), icon: 'tim-icons icon-book-39 text-primary' }"
                v-if="$permissions.sidebarTraining()">

                <sidebar-item :link="{ name: $t('common.competencies'), path: '/socrates/ui/training/competencies' }"
                    v-if="$auth.hasPermission('competency.manage')">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.competency-grids'), path: '/socrates/ui/training/competency-grids' }"
                    v-if="$auth.hasPermission('grid.manage')">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.degrees'), path: '/socrates/ui/training/degrees' }"
                    v-if="$auth.hasPermission('degree.manage')">
                </sidebar-item>

                <sidebar-item :link="{ name: $t('common.registrations'), path: '/socrates/ui/training/registrations' }"
                    v-if="$auth.hasPermission('registration.manage')">
                </sidebar-item>

            </sidebar-item>

            <!--
            <sidebar-item :link="{ name: $t('common.reports'), icon: 'tim-icons icon-line-chart text-info' }"
                v-if="$auth.hasPermission('dashboard.access-global-reports')"
            >
                <sidebar-item :link="{ name: $t('reports.cohorts'), path: '/socrates/ui/reports/cohorts' }">
                </sidebar-item>

            </sidebar-item>
            -->
            
            <sidebar-links :link="{ name: $t('common.settings'), icon: 'tim-icons icon-settings text-default' }"
                v-if="$permissions.sidebarSettings()">

                <li class="nav-item" v-if="$auth.hasOnePermission(['xapi-extra.observe', 'xapi-extra.manage'])">
                    <a href="/lrs" class="nav-link" target="_blank">
                        <span class="nav-link-text">LRS</span>
                    </a>
                </li>

                <li class="nav-item" v-if="$auth.user.admin">
                    <a :href="docsUrl" class="nav-link" target="_blank">
                        <span class="nav-link-text">Documentation</span>
                    </a>
                </li>

                <sidebar-item v-if="$auth.user.admin"
                    :link="{ name: $t('common.astral-import'), path: '/socrates/ui/settings/astral-import' }"
                >
                </sidebar-item>

            </sidebar-links>

        </template>
    </side-bar>
</template>

<script>
    export default {

        computed: {

            docsUrl() {
                return this.$baseURL + '/docs'
            }
        },

        methods: {

            hideSidebar() {
                this.$sidebar.displaySidebar(false);
            }
        }
    }
</script>
